function escapeHtml(text: string): string {
  return text
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
}

export function toEditorCompatibleHtml(raw: string): string {
  const input = String(raw || '').trim()
  if (!input) return ''

  // Old entries were sometimes plain text; convert to paragraph HTML for editor.
  if (!input.includes('<')) {
    return input
      .split(/\n{2,}/)
      .map((block) => block.trim())
      .filter(Boolean)
      .map((block) => `<p>${escapeHtml(block).replace(/\n/g, '<br/>')}</p>`)
      .join('')
  }

  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return input
  }

  try {
    const doc = new DOMParser().parseFromString(`<div id="__root">${input}</div>`, 'text/html')
    const root = doc.getElementById('__root')
    if (!root) return input

    // Default width/align for legacy images so editor + public CSS can control them.
    const imgs = root.querySelectorAll('img')
    imgs.forEach((img) => {
      const existing = Number(img.getAttribute('data-width-percent') || '')
      if (!Number.isFinite(existing) || existing <= 0) {
        img.setAttribute('data-width-percent', '100')
      }
      if (!img.getAttribute('data-align')) {
        img.setAttribute('data-align', 'center')
      }
      const style = img.getAttribute('style') || ''
      if (!/width\s*:/i.test(style)) {
        const w = img.getAttribute('data-width-percent') || '100'
        const nextStyle = `${style}${style && !style.trim().endsWith(';') ? ';' : ''}width: ${w}%; max-width: 100%; height: auto; display: block; margin: 0.75rem auto;`
        img.setAttribute('style', nextStyle)
      }
    })

    return root.innerHTML
  } catch {
    return input
  }
}

